import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Device } from '@capacitor/device';
import { AppVersionService } from 'src/app/services/app-version.service';

@Component({
    selector: 'app-enviroment-state',
    imports: [TranslateModule, CommonModule],
    templateUrl: './enviroment-state.component.html',
    styleUrl: './enviroment-state.component.scss'
})
export class EnviromentStateComponent implements OnInit {

  environment = environment;
  platform: string = '';
  deviceInfo: any;
  isIos: boolean = false;
  appVersion$;

  constructor(private appVersionService: AppVersionService) {
    this.appVersion$ = this.appVersionService.version$;
  }

  async ngOnInit() {
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
    this.deviceInfo = await Device.getInfo();
    this.platform = this.deviceInfo.platform;
  }
}